<template>
  <div>
    <v-row no-gutters>
      <v-col class="pa-2" cols="12" md="6">
        <v-file-input
          v-model="obj.file"
          accept="image/*"
          clearable
          dense
          label="تصویر"
          outlined
        />
      </v-col>

      <v-col class="pa-2" cols="12" md="6">
        <v-btn
          :disabled="!obj.file"
          :loading="loading"
          class="white--text"
          color="green"
          depressed
          @click="getInfo"
        >
          آپلود تصویر
        </v-btn>
      </v-col>

      <v-col class="pa-2" cols="12">
        <v-textarea
          v-model="obj.description"
          dense
          label="توضیحات مورد نیاز"
          outlined
        />
      </v-col>

      <v-col class="pa-2" cols="12">
        <v-fade-transition mode="out-in">
          <v-progress-linear
            v-if="loading"
            key="laoding"
            color="blue"
            height="10"
            indeterminate
            query
            rounded
          />

          <v-textarea
            v-else-if="!!html"
            key="text"
            v-model="html"
            label="اطلاعات تصویر"
            outlined
            rows="8"
          />
        </v-fade-transition>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { imageToPlainTextAi } from "@/utilities/ImageGallery";

export default {
  name: "imageToTextInfAi",

  data: () => ({
    loading: false,
    obj: {
      file: null,
      description:
        "مواد تشکیل دهنده\n" +
        "ویژگی ها و کاربردهای محصول\n" +
        "شرایط نگهداری\n" +
        "روش تهیه یا نصب\n" +
        "وزن/حجم/اندازه",
    },
    html: null,
  }),

  methods: {
    getInfo() {
      this.loading = true;

      imageToPlainTextAi(this.obj)
        .then(({ data }) => {
          this.html = data.data?.translated;
        })
        .catch(({ response }) => {
          this.$toast.error(
            response?.data?.message || "خطا در دریافت اطلاعات!",
          );
        })
        .finally(() => (this.loading = false));
    },
    setInfo() {
      if (!this.html) return this.$toast.error("تصویری انتخاب نشده است!");
      else this.$emit("save", this.html);
    },
  },
};
</script>

<style scoped></style>
